import { Component } from '@angular/core';
import { DepositsComponent } from './deposits.component';

@Component({
  selector: 'eid-deposits-mobile',
  templateUrl: './deposits.mobile.component.html',
  styleUrls: ['./deposits.mobile.component.scss']
})
export class DepositsMobileComponent extends DepositsComponent {}
